"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzRadio = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var react_bootstrap_1 = require("react-bootstrap");

require("./SzRadio.scss");

exports.SzRadio = react_1.forwardRef(function (props, ref) {
  var checked = props.checked,
      className = props.className,
      disabled = props.disabled,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      id = props.id;
  var formCheckClasses = classnames_1.default('d-flex align-content-center sz-radio', className, {
    checked: checked
  });
  return react_1.default.createElement(react_bootstrap_1.Form.Check, {
    custom: true,
    className: formCheckClasses,
    disabled: disabled,
    name: name,
    type: 'radio',
    label: label,
    checked: checked,
    onChange: onChange,
    value: value,
    id: id,
    ref: ref
  });
});
exports.default = exports.SzRadio;